import { blue, gray, red, transparent } from "./colors";

export const boxShadow = {
  none: "none",
  primary: `0px 2px 6px ${transparent[15]}`,
};

export const borderRadius = {
  none: 0,
  small: "0.25rem", // 4px
  primary: "0.5rem", // 8px
  full: 99,
};

export const borderColors = {
  primary: gray[40],
  hover: gray[60],
  focused: blue[100],
  error: red[100],
};

const borders = {
  primary: `1px solid ${borderColors.primary}`,
};

export default borders;
